import { useEffect, useState } from 'react';

/**
 * Hook to detect if "superpower" URL parameter is present.
 * When enabled, grants authenticated users temporary admin-like editing capabilities.
 *
 * Usage: Add ?superpower to URL to enable inline editing of transaction/donation fields.
 *
 * @returns boolean - true if ?superpower parameter is in URL
 */
export function useSuperpowerMode(): boolean {
  const [isEnabled, setIsEnabled] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setIsEnabled(params.has('superpower'));
  }, []);

  return isEnabled;
}
